import ky from 'lib/ky'

const $ = document.querySelector.bind(document)

export default class FlashMessages {
  static async render () {
    if (document.body.dataset.cachedPage === undefined) return

    const { flash, csrf } = await this.ready
    flash && this.renderFlash(flash)
    csrf && this.renderCsrf(csrf)
  }

  static renderFlash (flash) {
    for (const key in flash) {
      if (flash[key]) {
        document.getElementById('flash_root').insertAdjacentHTML(
          'afterbegin',
          `<div class="callout flash ${key}" data-closable>` +
            `<h6>${flash[key]}</h6>` +
            '<button class="close_button" aria-label="Dismiss alert" type="button" data-close>' +
              '<span aria-hidden="true">&times;</span>' +
            '</button>' +
          '</div>'
        )
      }
    }
  }

  static renderCsrf ({ token = null, param = null }) {
    if (token) {
      $('meta[name=csrf-token]')?.remove()
      document.head.insertAdjacentHTML('afterbegin', `<meta name="csrf-token" content="${token}">`)
    }
    if (param) {
      $('meta[name=csrf-param]')?.remove()
      document.head.insertAdjacentHTML('afterbegin', `<meta name="csrf-param" content="${param}">`)
    }
  }
}

// Fired at module load, not DOMContentLoaded, to win the session-cookie race with order creation on cached pages.
FlashMessages.ready = document.body.dataset.cachedPage === undefined
  ? Promise.resolve({})
  : ky.get('/flash_w_csrf.json').json()
